<template>
  <!-- 需求管理 -->
  <div style="background-color: #f5f5f5; margin-top: 0.7rem">
    <div class="requirement_management comBox">
      <div class="left">
        <leftTemplate3 :left_tabShow="chuan"></leftTemplate3>
      </div>
      <div class="right" style="position: relative">
        <div style="height: 0.08rem"></div>
        <div style="
            display: flex;
            position: absolute;
            top: 0.1rem;
            right: 0.16rem;
            z-index: 1;
          ">
          <div style="cursor: pointer" class="topBtn" @click="
            title2 = '发布需求';
          checked = true;
          ">
            发布需求
          </div>
          <div style="
              cursor: pointer;
              color: #333333;
              background: transparent;
              border: 1px solid #e5e6eb;
            " class="topBtn" @click="handleService">
            联系客服
          </div>
        </div>
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
          <el-tab-pane :label="item.label" :name="item.name" v-for="item in activeList" :key="item">
            <el-table ref="multipleTableRef" :data="list" style="width: 100%" height="650">
              <el-table-column property="name" label="需求内容">
                <template #default="scope">
                  <div style="display: flex">
                    <!-- <div style="" class="table_img"></div> -->
                    <div class="table_information">
                      <div style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          -webkit-box-orient: vertical;
                          -webkit-line-clamp: 1;
                          color: #333333;
                          font-size: 0.16rem;
                          font-weight: bold;
                        ">
                        {{ scope.row.projectName }}
                      </div>
                      <div style="
                          display: flex;
                          justify-content: flex-start;
                          margin-top: 0.04rem;
                        ">
                        <span style="
                            display: flex;
                            width: 1rem;
                            margin-right: 0.4rem;
                          ">
                          <div class="table_title">工作地点：</div>
                          <Tooltip class="table_name" :text="scope.row.workPlace ? scope.row.workPlace : '暂无'
                            ">
                          </Tooltip>
                        </span>
                        <span style="
                            width: 2rem;
                            display: flex;
                            margin-right: 0.2rem;
                          ">
                          <div class="table_title">交付时间：</div>
                          <Tooltip class="table_name" :text="com_date.com_date.timestamp_string(
                            scope.row.deliveryTime,
                            false,
                            `-`,
                            `:`
                          )
                            ">
                          </Tooltip>
                        </span>
                        <span style="
                            width: 2rem;
                            display: flex;
                            margin-right: 0.2rem;
                          ">
                          <div class="table_title">技能类型：</div>
                          <Tooltip class="table_name" :text="scope.row.skillType ? scope.row.skillType : `暂无`
                            ">
                          </Tooltip>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="需求预算" width="150" align="center">
                <template #default="scope">
                  <div style="color: #c01a26">
                    {{ scope.row.price ? "￥" : ""
                    }}{{ (scope.row.price / 1).toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName == 'first1'" label="报名人数" width="150" align="center">
                <template #default="scope">
                  <div style="color: #3fa4ed" @click="handlePeopleSelect1(index, scope.row)">
                    {{ scope.row.signUpNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="activeName == 'second'" label="需求文件" width="90" align="center">
                <template #default="scope">
                  <div style="color: #3fa4ed" @click="handleFileView(scope.$index, scope.row)">
                    查看
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="合作人" v-if="activeName != 'first1'" width="150" align="center">
                <template #default="scope">
                  <span @click="Details(scope.$index, scope.row)">
                    {{ scope.row.partner }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="退款状态" width="150" align="center">
                <template #default="scope">
                  {{ scope.row.refundFlag ? "已退款" : "未退款" }}
                  <el-tag
                    class="ml-2"
                    v-if="scope.row.refundFlag == 0"
                    type="success"
                    >退款成功</el-tag
                  >
                  <el-tag
                    class="ml-2"
                    v-if="scope.row.refundFlag == 1"
                    type="danger"
                    >退款失败</el-tag
                  >
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                v-if="activeName == 'first1' || activeName == 'four'"
                label="是否已删除"
                width="90"
                align="center"
                >
                  <template #default="{ row }">
                    <el-tag
                    class="ml-2"
                    :type="row.delFlag == 0 ? 'success' : 'danger'"
                    >{{ row.delFlag == 0 ? "未删除" : "已删除" }}</el-tag
                  >
                </template>
              </el-table-column> -->
              <el-table-column label="操作" v-if="activeName != 'four3'" :width="355" align="center">
                <template #default="scope">
                  <div style="display: flex; justify-content: center; width: 100%" v-if="activeName == 'first1' &&
                    scope.row.delFlag != 1 &&
                    scope.row.choiceFlag == 0
                    ">
                    <!-- <div
                      @click="getInfo(scope.$index, scope.row)"
                      style="color: #C01A26; line-height: 0.43rem; flex: none"
                    >
                      查看
                    </div> -->
                    <div class="topBtn" @click="handlePeopleSelect(scope.$index, scope.row)">
                      选择合作人
                    </div>

                    <div @click="handleDel(scope.$index, scope.row)" style="
                        margin-left: 0.1rem;
                        line-height: 0.43rem;
                        color: red;
                        flex: none;
                      ">
                      删除
                    </div>
                  </div>
                  <div v-if="activeName == 'first1' &&
                    scope.row.delFlag != 1 &&
                    scope.row.choiceFlag == 1
                    " style="
                      font-size: 0.14rem;
                      color: #000000;
                      text-align: center;
                      width: 100%;
                    ">
                    等待对方签单...
                  </div>
                  <div v-if="activeName == 'first2'" style="
                      font-size: 0.14rem;
                      color: #000000;
                      text-align: center;
                      width: 100%;
                    ">
                    <div v-if="scope.row.expireFlag == 0">等待对方合作...</div>
                    <div v-if="scope.row.expireFlag == 1">
                      未确认合作,订单已过期
                    </div>
                  </div>
                  <div style="display: flex; justify-content: center; width: 100%" v-if="activeName == 'first'">
                    <div v-if="scope.row.payFlag == 0">
                      <div class="topBtn" @click="PaymentChoice(scope.$index, scope.row)">
                        付款
                      </div>
                      <div style="font-size: 0.12rem; color: #86909c">
                        24小时未确认合作，订单将取消
                      </div>
                    </div>
                    <!-- <div v-if="scope.$index != 1">
                      <div
                        @click="
                          handleCooperationVerify(scope.$index, scope.row)
                        "
                        class="topBtn"
                      >
                        付款
                      </div>
                      <div style="font-size: 0.12rem; color: #86909c">
                        24小时未确认合作，订单将取消
                      </div>
                    </div> -->
                    <!-- <div
                      v-if="scope.$index == 1"
                      style="
                        font-size: 0.14rem;
                        color: #000000;
                        text-align: center;
                        width: 100%;
                      "
                    >
                      等待对方确认...
                    </div> -->
                  </div>

                  <div style="display: flex; justify-content: center; width: 100%" v-if="activeName == 'second'">
                    <div v-if="scope.row.deliveryFile" class="topBtn" @click="handleAccount(scope.$index, scope.row)">
                      结算
                    </div>
                    <div v-else style="
                        font-size: 0.14rem;
                        color: #000000;
                        text-align: center;
                        width: 100%;
                      ">
                      等待对方交付...
                    </div>
                    <!-- <div @click="handleCooperation(scope.$index, scope.row)"
											style="margin-left: 0.1rem;line-height: 0.43rem;color:#86909C;">终止合作</div> -->
                  </div>
                  <div style="
                      display: flex;
                      justify-content: space-around;
                      width: 100%;
                    ">
                    <div class="topBtn" style="
                        width: 50%;
                        padding: 0 0;
                        margin-left: 0;
                        background: transparent;
                        border: 1px solid #c01a26;
                        color: #c01a26;
                      " v-if="activeName == 'third' && scope.row.invoicingFlag == 0
                        " @click="myDebitView(scope.row)">
                      申请发票
                    </div>
                    <div class="topBtn" style="
                        width: 50%;
                        padding: 0 0;
                        margin-left: 0;
                        background: transparent;
                        border: 1px solid #9aa2ac;
                        color: #9aa2ac;
                      " v-if="activeName == 'third' && scope.row.invoicingFlag == 1
                        ">
                      已申请
                    </div>
                    <div class="topBtn" style="width: 50%; padding: 0 0; margin-left: 0.2rem" v-if="activeName == 'third'"
                      @click="handleEvaluate(scope.$index, scope.row)">
                      合作评价
                    </div>
                  </div>
                  <div style="display: flex; justify-content: center; width: 100%" v-if="activeName == 'five'">
                    <div @click="handleDel(scope.$index, scope.row)" style="
                        margin-left: 0.1rem;
                        line-height: 0.43rem;
                        color: #ff2929;
                      ">
                      删除
                    </div>
                  </div>
                  <div style="display: flex; justify-content: center" v-if="activeName == 'four12'">
                    <!-- <div
                      @click="handleEvaluate(scope.$index, scope.row)"
                      class="topBtn1"
                    >
                      评价
                    </div> -->
                  </div>
                  <div style="
                      display: flex;
                      justify-content: space-around;
                      width: 100%;
                    ">
                    <div class="topBtn" style="
                        width: 50%;
                        padding: 0 0;
                        margin-left: 0;
                        background: transparent;
                        border: 1px solid #c01a26;
                        color: #c01a26;
                      " v-if="activeName == 'four12' && scope.row.invoicingFlag == 0
                        " @click="myDebitView(scope.row)">
                      申请发票
                    </div>
                    <div class="topBtn" style="
                        width: 50%;
                        padding: 0 0;
                        margin-left: 0;
                        background: transparent;
                        border: 1px solid #9aa2ac;
                        color: #9aa2ac;
                      " v-if="activeName == 'four12' && scope.row.invoicingFlag == 1
                        ">
                      已申请
                    </div>
                    <div v-if="activeName == 'four12'" @click="ckBtn(scope.row)"
                      style="width: 50%; padding: 0 0; margin-left: 0.2rem;cursor: pointer;" class="topBtn1">
                      查看
                    </div>
                    <div v-if="activeName == 'four12'" style="width: 50%; padding: 0 0; margin-left: 0.2rem"
                      class="topBtn1">
                      <a :href="scope.row.deliveryFile" style="color: #FFF;" :download="scope.row.projectName">下载</a>
                    </div>
                    <div v-if="activeName == 'four12'" @click="EvaluationContent(scope.$index, scope.row)"
                      style="width: 50%; padding: 0 0; margin-left: 0.2rem" class="topBtn1">
                      评价列表
                    </div>
                  </div>
                  <div style="
                      display: flex;
                      justify-content: space-around;
                      width: 100%;
                    ">
                    <div v-if="activeName == 'four'" @click="anewSend(scope.row)"
                      style="width: 50%; padding: 0 0; margin-left: 0.2rem;cursor: pointer;" class="topBtn1">
                      重新发布
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 评价列表 -->
    <el-dialog title="评价列表" v-model="dialogVisible" width="480px" v-if="dialogVisible" :close-on-click-modal="false">
      <el-table v-if="EvaluationContentList.length" :data="EvaluationContentList" style="width: 100%"
        :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="评价星级" prop="evaluate_star"></el-table-column>
        <el-table-column label="评价内容" prop="evaluate_content"></el-table-column>
        <el-table-column label="评价方" prop="BothParties"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 删除弹框 -->
    <el-dialog title="" v-model="dialogDelVisible" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        是否确认删除此需求？
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="dlt">确认</div>
      </div>
    </el-dialog>
    <!-- 终止合作弹框 -->
    <el-dialog title="" v-model="dialogCooperationVisible" align-center width="480px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        确认要终止合作吗？
      </div>
      <div style="margin: 0.16rem 0; color: #86909c; text-align: center">
        终止合作，平台将扣除2%的费用
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogCooperationVisible = false">
          取消
        </div>
        <div class="dataBtnSubmit">确认</div>
      </div>
    </el-dialog>
    <!-- 评价 -->
    <el-dialog title="合作评价" v-model="dialogEvaluateVisible" align-center :before-close="handleClose1" width="480px"
      :close-on-click-modal="false">
      <div style="
          color: #86909c;
          font-size: 0.14rem;
          text-align: center;
          margin-bottom: 0.18rem;
        ">
        评价星级
      </div>

      <div class="rate" style="display: flex; justify-content: center">
        <el-rate v-model="evaluateObj.evaluateStar" size="large" />
      </div>
      <div style="color: #000000; margin-bottom: 0.16rem; font-size: 0.14rem">
        评价内容
      </div>
      <el-input v-model="evaluateObj.evaluateContent" maxlength="30" placeholder="输入评价内容" show-word-limit
        type="textarea" />
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="
          evaluateObj = {};
        dialogEvaluateVisible = false;
        ">
          取消
        </div>
        <div class="dataBtnSubmit" @click="evaluate">确认</div>
      </div>
    </el-dialog>

    <!-- 结算 -->
    <el-dialog title="结算" v-model="dialogAccountVisible" align-center width="50%" :close-on-click-modal="false">
      <div style="font-size: 0.2rem; font-weight: bold">
        <!-- 5月24日广州南沙活动拍摄 -->
        {{ settlementObj.projectName }}
      </div>
      <div style="margin: 0.12rem 0 0.24rem; font-size: 0.14rem; display: flex">
        <div>工作地点： {{ settlementObj.workPlace }}</div>
        <div>
          交付时间：{{
            com_date.com_date.timestamp_string(
              settlementObj.deliveryTime,
              false,
              "-",
              ":"
            )
          }}
        </div>
        <div>技能类型：{{ settlementObj.skillType }}</div>
      </div>
      <div style="font-size: 0.14rem; color: #86909c; margin-bottom: 0.12rem">
        需求描述
      </div>
      <div style="color: #333333; font-size: 0.14rem; line-height: 0.3rem">
        {{ settlementObj.projectDescription }}
        <!-- 1、甲方仅需杭州当地创作人，异地勿报名，甲方提供视频，有参考样片，有截图，创作人提供调色服务
        <br />
        2、总时长4分钟，分场景四段剧情片，成片交付时间26日下午5点之前 -->
      </div>
      <div style="
          font-size: 0.14rem;
          color: #86909c;
          margin-bottom: 0.12rem;
          margin-top: 0.24rem;
        ">
        交付文件
      </div>
      <div style="
          background: #f7f8fa;
          padding: 0.12rem;
          display: flex;
          justify-content: space-between;
        " v-for="(item, index) in settlementObj.deliveryFile" :key="index">
        <div style="display: flex; justify-content: flex-start">
          <div class="fileIcon"></div>
          <Tooltip style="width: 0.7rem" :text="item.name"> </Tooltip>
        </div>

        <!-- <div class="downloadIcon" v-download="item.url"></div> -->
        <a class="downloadIcon" :href="item.url"></a>
        <!--   @click="downloadImage(item.url, item.name)" -->
      </div>
      <div style="border-bottom: 1px solid #e5e6eb; margin-bottom: 0.2rem"></div>
      <div style="display: flex">
        <div style="color: #333333; font-size: 0.14rem; margin-top: 0.09rem">
          结算金额：
        </div>
        <div style="font-size: 0.24rem; color: #c01a26">
          ￥{{ (settlementObj.price / 1).toFixed(2) }}
        </div>
      </div>

      <div style="font-size: 0.14rem; color: #86909c; margin: 0.2rem 0">
        结算后，您在平台托管的金额将发放给合作者
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="dialogAccountVisible = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="SettleAnAccount">确认</div>
      </div>
    </el-dialog>

    <!-- 查看文件 -->
    <el-dialog title="查看文件" v-model="dialogAccountViewVisible" align-center width="50%" :close-on-click-modal="false">
      <div style="font-size: 0.14rem; color: #86909c; margin-bottom: 0.12rem">
        交付文件
      </div>
      <div style="
          background: #f7f8fa;
          padding: 0.12rem;
          display: flex;
          justify-content: space-between;
        " v-for="(item, index) in settlementObj.deliveryFile" :key="index">
        <div style="display: flex; justify-content: flex-start">
          <div class="fileIcon"></div>
          <Tooltip style="width: 0.7rem" :text="item.name"> </Tooltip>
        </div>

        <a class="downloadIcon" :href="item.url"></a>
        <!--  -->
      </div>
    </el-dialog>
    <!-- 合作人数 -->
    <el-dialog title="报名人数" v-model="peopleVisible" align-center width="600px" :close-on-click-modal="false">
      <numberOfApplicants></numberOfApplicants>
    </el-dialog>
    <!-- 合作-->
    <el-dialog :title="title1" v-model="peopleSelectVisible" align-center width="600px" :close-on-click-modal="false">
      <numberOfApplicantsSelect v-for="(item, index) in list1" :key="index" :item="item" :type="title1 == '查看合伙人' ? 1 : 0"
        @click="selectPeople(item)" ref="numberOfApplicantsSelectRef" />
      <div style="display: flex; justify-content: center; margin-top: 0.01rem">
        <el-pagination background layout="prev, pager, next" :total="form.total" />
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="peopleSelectVisible = false">
          取消
        </div>
        <div class="dataBtnSubmit" v-if="title1 != '查看合伙人'" @click="handlePay">
          确认
        </div>
      </div>
    </el-dialog>

    <!-- 付款 -->
    <el-dialog title="付款" v-model="payVisible" align-center width="500px" :close-on-click-modal="false">
      <div style="
          font-size: 0.14rem;
          color: #86909c;
          text-align: center;
          margin-bottom: 0.16rem;
        ">
        支付项目费用到平台担保，并获得创作者联系方式
      </div>
      <div style="
          display: flex;
          justify-content: center;
          font-size: 0.14rem;
          margin-bottom: 0.2rem;
          margin-top: 0.2rem;
        ">
        应付金额：
        <span style="color: #c01a26"> ￥ </span>
        <span style="font-size: 0.24rem; color: #c01a26; margin-top: -0.09rem">{{ (Payment.price / 1).toFixed(2) }}</span>
      </div>
      <div style="font-size: 0.14rem; margin-bottom: 0.12rem; color: #000000">
        选择支付方式
      </div>
      <div style="display: flex">
        <div class="payItem" v-for="(item, index) in paymentOptions" :key="index"
          :class="{ selected: selectedPaymentOption === item }" @click="selectPaymentOption(item)">
          <div style="width: 0.24rem; height: 0.24rem; margin-right: 0.04rem">
            <img v-if="item.name == '微信'" src="@/assets/img/weixin.png" style="width: 100%; height: 100%" />
            <img v-else src="@/assets/img/zhifubao.png" style="width: 100%; height: 100%" />
          </div>
          <div>{{ item.name }}</div>
          <!-- <div v-if="selectedPaymentOption === item" class="triangle">
            <div class="checkmark"></div>
          </div> -->
        </div>
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="payVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="Payment1">确认</div>
      </div>
    </el-dialog>
    <!-- 确认合作 -->
    <el-dialog title="" v-model="cooperationVisible" align-center width="580px" :close-on-click-modal="false">
      <div style="width: 0.4rem; height: 0.4rem; margin: 0 auto">
        <img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
      </div>

      <div style="text-align: center; font-size: 0.16rem; margin: 0.16rem 0">
        是否确认与此创作者进行合作？合作后平台将扣除3%手续费？
      </div>

      <div style="
          font-size: 0.12rem;
          display: flex;
          justify-content: center;
          margin-top: 0.16rem;
          margin-bottom: 0.2rem;
        ">
        <el-radio-group v-model="radio2" style="margin-top: -0.03rem">
          <el-radio size="small"></el-radio>
        </el-radio-group>
        <div style="color: #333333">已阅读并同意</div>
        <div style="color: #c01a26" @click="openagreement('yyfwxy')">
          《标识山西扣费协议》
        </div>
      </div>

      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="cooperationVisible = false">取消</div>
        <div class="dataBtnSubmit" @click="Verify">确认</div>
      </div>
    </el-dialog>
    <!-- 客服 -->
    <el-dialog title="" :close-on-click-modal="false" v-model="serviceVisible" align-center width="580px">
      <div style="text-align: center">
        <img style="
            width: 1.8rem;
            margin: 0 auto;
            height: 1.8rem;
            border-radius: 0.12rem;
            border: 1px solid #e5e6eb;
          " src="@/assets/ewm.jpg" alt="" />
      </div>

      <div style="
          text-align: center;
          margin-top: 0.12rem;
          margin-bottom: 0.2rem;
          font-size: 0.14rem;
          color: #333333;
        ">
        扫描二维码，添加客服微信号
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnSubmit" @click="serviceVisible = false">确认</div>
      </div>
    </el-dialog>

    <!-- 评价内容 -->
    <el-dialog title="评价内容" v-model="dialogEvaluateVisible1" align-center width="480px" :close-on-click-modal="false">
      <div style="
          color: #86909c;
          font-size: 0.14rem;
          text-align: center;
          margin-bottom: 0.18rem;
        ">
        评价星级
      </div>
      <div class="rate" style="display: flex; justify-content: center">
        <el-rate disabled v-model="EvaluationContentObj.evaluateStar" size="large" />
      </div>
      <div style="color: #000000; margin-bottom: 0.16rem; font-size: 0.14rem">
        评价内容
      </div>
      <el-input v-model="EvaluationContentObj.evaluateContent" maxlength="30" disabled placeholder="输入评价内容"
        show-word-limit type="textarea" />
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="
          EvaluationContentObj = {};
        dialogEvaluateVisible1 = false;
        ">
          取消
        </div>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title="title2" :before-close="handleClose" :close-on-click-modal="false" v-model="checked" align-center
      width="800px">
      <el-form :model="form1" label-width="100px" ref="formRef" :rules="rules">
        <el-form-item label="项目名称" prop="projectName" :span="24">
          <el-input v-model="form1.projectName" :disabled="title2 == '查看发布需求'" placeholder="请填写项目名称" />
        </el-form-item>
        <el-form-item label="项目描述" prop="projectDescription">
          <el-input type="textarea" :disabled="title2 == '查看发布需求'" v-model="form1.projectDescription"
            placeholder="填写详细的描述，可更准确快速匹配合适创作人，可含：需求背景、时长、风格、投放渠道等..." />
        </el-form-item>
        <el-form-item label="联系方式" prop="contactInfo">
          <el-input v-model="form1.contactInfo" :disabled="title2 == '查看发布需求'" placeholder="请填写联系方式" />
        </el-form-item>
        <el-form-item label="预算价格" prop="price">
          <el-input oninput="value=value.replace(/[^\d.]/g, '')" v-model="form1.price" :disabled="title2 == '查看发布需求'"
            placeholder="请输入价格">
            <template #append>元</template>
          </el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="交付日期" prop="deliveryTime">
              <el-date-picker v-model="form1.deliveryTime" :disabled="title2 == '查看发布需求'" type="date" format="YYYY-MM-DD"
                value-format="x" placeholder="选择交付日期" :disabled-date="disabledDate" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作地点" prop="workPlace">
              <el-input v-model="form1.workPlace" :disabled="title2 == '查看发布需求'" placeholder="请输入工作地点" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="技能类型" prop="skillType">
          <el-input v-model="form1.skillType" :disabled="title2 == '查看发布需求'" placeholder="请输入技能类型" />
        </el-form-item>
        <div v-if="title2 != '查看发布需求'" style="
            font-size: 0.12rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-top: 0.16rem;
            margin-bottom: 0.2rem;
          ">
          <el-checkbox v-model="radio" />
          <div style="color: #333333; margin-left: 0.1rem">已阅读并同意</div>
          <div style="color: #c01a26" @click="openagreement('zywsyxy')">
            《找业务使用协议》
          </div>
        </div>
      </el-form>
      <div style="display: flex; justify-content: center; margin-top: 10px">
        <div class="dataBtn dataBtnQx" style="cursor: pointer;" @click="handleClose()">取消</div>
        <div class="dataBtn" style="cursor: pointer;" v-if="title2 != '查看发布需求'" @click="submitForm()">
          确认发布
        </div>
      </div>
    </el-dialog>
    <!-- 手机号 -->
    <el-dialog title="合作者手机号" v-model="PartnersMobileNumber" align-center width="480px" :close-on-click-modal="false">
      <div style="text-align: center">联系方式</div>
      <div style="text-align: center; padding-top: 5px; font-size: 20px">
        {{ PartnersMobileNumber1 }}
      </div>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="PartnersMobileNumber = false">
          取消
        </div>
        <div class="dataBtnSubmit" @click="PartnersMobileNumber = false">
          确认
        </div>
      </div>
    </el-dialog>
    <two-dimensional-code ref="TwoDimensionalCodeRef" :CloseQrCode="CloseQrCode" />
  </div>
</template>

<script lang="ts" setup>
import numberOfApplicantsSelect from "@/components/numberOfApplicantsSelect.vue";
import numberOfApplicants from "@/components/numberOfApplicants.vue";
import leftTemplate3 from "@/components/leftTemplate3.vue";
import customPopUps from "@/components/custom-pop-ups.vue";
import { ref, reactive, onMounted, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import type { TabsPaneContext } from "element-plus";
import { ElTable } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
import com_date from "@/assets/js/common.js";
import { ElMessage, ElLoading } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import TwoDimensionalCode from "./components/TwoDimensionalCode.vue";
import Tooltip from "@/components/Tooltip/index.vue";
const TwoDimensionalCodeRef = ref<any>();
const numberOfApplicantsSelectRef = ref<any>();
document.title = "标识山西-发布的需求";
const dialogTableVisible = ref(false);
const activeName = ref("first1");
const route = useRoute();
const router = useRouter();
import axios from "axios";
import { json } from "stream/consumers";
const PartnersMobileNumber = ref(false);
const chuan = ref("requirement_publish");
const dialogVisible = ref(false);
const disabledDate = (time) => {
  return time.getTime() < Date.now();
};

const activeList = ref([
  {
    label: "已发布",
    name: "first1",
    satus: 1,
  },
  {
    label: "待确认",
    name: "first",
    satus: 2,
  },
  {
    label: "待合作", // 已付款
    name: "first2",
    satus: 3,
  },
  {
    label: "进行中",
    name: "second",
    satus: 4,
  },
  {
    label: "待评价",
    name: "third",
    satus: 5,
  },
  {
    label: "已终止",
    name: "four",
    satus: 6,
  },
  {
    label: "已评价",
    name: "four12",
    satus: 7,
  },
  {
    label: "已退款",
    name: "four3",
    satus: 8,
  },
]);
const radio = ref(false);
const form = ref({
  condition: {
    state: 1,
  },
  pageIndex: 1,
  pageSize: 12,
  total: 0,
});
const checked = ref(false);
const form1 = ref({
  contactInfo: "",
  deliveryTime: "",
  price: null,
  projectName: "",
  workName: "",
  projectDescription: "",
  skillType: "",
  workPlace: "",
});

type Form = {
  contactInfo: string;
  deliveryTime: string;
  price: number;
  projectName: string;
  projectDescription: string;
  skillType: string;
  workPlace: string;
};
type Rules = {
  [K in keyof Form]?: Array<FormItemRule>;
};
const ckBtn = (item: any) => {
  title2.value = "查看发布需求";
  checked.value = true;
  form1.value = item;
}
const formRef = ref<FormInstance>();
const rules = reactive<FormRules<RuleForm>>({
  contactInfo: [
    { required: true, message: "请输入联系方式", trigger: "change" },
  ],
  deliveryTime: [
    { required: true, message: "请选择交付日期", trigger: "change" },
  ],
  price: [{ required: true, message: "请输入价格", trigger: "change" }, {
    validator: (rule, value, cb) => {
      if (String(value).trim() == 'null') return;
      if (String(value).indexOf(".") != -1) {
        return cb(new Error('请输入正整数'));
      }
      return cb();
    }, trigger: 'blur'
  }],
  projectName: [
    { required: true, message: "请输入项目名称", trigger: "change" },
  ],
  projectDescription: [
    { required: true, message: "请输入项目描述", trigger: "change" },
  ],
});
const dialogEvaluateVisible1 = ref(false);
const EvaluationContentObj = ref({});
const EvaluationContentList = ref([]);
const anewSend = (item: any) => {
  title2.value = '发布需求';
  checked.value = true;
  let {
    contactInfo,
    deliveryTime,
    price,
    projectName,
    workName,
    projectDescription,
    skillType,
    workPlace } = JSON.parse(JSON.stringify(item))
  form1.value = {
    contactInfo,
    deliveryTime,
    price,
    projectName,
    workName,
    projectDescription,
    skillType,
    workPlace
  };
}
const myDebitView = (row) => {
  router.push({
    path: "/invoiceDebit",
    query: {
      arry: row.id,
      type: "add",
      type1: "1",
      price: row.price,
      needNo: row.needNo,
    },
  });
};

const Details = (index, row) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: { id: row.partnerId },
  });
};
const EvaluationContent = (index, row) => {
  dialogVisible.value = true;
  EvaluationContentObj.value.id = row.id;
  Axios(
    "post",
    "/material//material/need/listEvaluate",
    {
      pageIndex: 1,
      pageSize: 20,

      condition: {
        needId: EvaluationContentObj.value.id,
      },
    },
    false,
    function (res) {
      if (res.data.code == 200) {
        console.log(
          "res.data.data.records.records,records",
          res.data.data.records[0]
        );
        if (res.data.data.records && res.data.data.records.length > 0) {
          res.data.data.records.forEach((e) => {
            if (
              e.evaluate_user_id ==
              JSON.parse(localStorage.getItem("userList")).memberId
            ) {
              e.BothParties = "甲方";
            } else {
              e.BothParties = "乙方";
            }
          });
        }
        EvaluationContentList.value = res.data.data.records;

        // EvaluationContentObj.value = res.data.data.records[0];
      } else {
        console.log(res);
      }
    }
  );
};
const submitForm = () => {
  if (!radio.value) {
    return ElMessage.error("请同意合同协议");
  }
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let obj = { ...form1.value };
      Axios("POST", "/material/material/need/sou", obj, false, function (res) {
        if (res.data.code == 200) {
          handleClose(true);
        } else {
          ElMessage.error(res.data.message);
        }
      });
    } else {
      return false;
    }
  });
};
const handleClose1 = () => {
  dialogEvaluateVisible.value = false;
  evaluateObj.value = {};
};
// const handleClose = (e: any) => {
//   checked.value = false;
//   form1.value = {
//     contactInfo: "",
//     deliveryTime: "",
//     price: null,
//     projectName: "",
//     workName: "",
//     projectDescription: "",
//     // signUpNum: null,
//     skillType: "",
//     workPlace: "",
//   };
//   // Check if formRef.value exists before accessing resetFields()
//   formRef.value && formRef.value.resetFields();
//   radio.value = false;
//   if (e) {
//     getList();
//   }
// };
const handleClose = (e) => {
  formRef.value.clearValidate();
  formRef.value.resetFields();
  radio.value = false;
  checked.value = false;
  if (e) {
    getList();
  }
};
const handleClick = (tab: TabsPaneContext, event: Event) => {
  activeList.value.forEach((e) => {
    if (e.name == tab.props.name) {
      form.value.condition.state = e.satus;
    }
  });
  list.value = [];
  getList();
};
const openagreement = (val) => {
  window.open(`/agreement?name=${val}`, "_bank");
};
watch(
  () => route.query.state,
  async (params) => {
    await nextTick();
    activeName.value = route.query.state ? route.query.state : "first1";
    handleClick({ props: { name: activeName.value } });
  },
  { immediate: true }
);
const handleDelete = (index, row) => {
  console.log(index, row);
};
const isMacOs = () => {
  return window.navigator.userAgent.includes("Macintosh");
};

const downloadImage = (imgsrc, name) => {
  const link = document.createElement("a");
  link.href = imgsrc;
  link.download = name;

  if (!isMacOs()) {
    // 如果不是 MacOS 则添加 target 属性
    link.target = "_blank";
  }

  document.body.appendChild(link);
  link.dispatchEvent(new MouseEvent("click"));
  document.body.removeChild(link);
};

// 表格
// 左侧点击
// condition中包state字段(待签单state = 1 / 已报名state = 0 /待确认 state = 2 / 已拒绝state = 3 / 进行中 state= 4 /待评价 state = 5 / 已评价 state = 6)
const list = ref([]);
const getList = () => {
  let obj = { ...form.value };
  for (let key in obj) {
    if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  }
  let obj1 = { ...obj.condition };
  for (let key in obj1) {
    if (obj1[key] === "" || obj1[key] === null || obj1[key] === undefined) {
      delete obj1[key];
    }
  }
  obj.condition = obj1;
  Axios(
    "post",
    "/material/material/need/myPublish",
    obj,
    false,
    function (res) {
      // console.log(res.data.code);

      if (res.data.code == 200) {
        list.value = res.data.data.records;
      } else {
        console.log(res);
      }
    }
  );
};
const title2 = ref("");
getList();
const getInfo = (index, row) => {
  Axios("get", `/material/material/need/${row.id}`, {}, false, function (res) {
    // console.log(res.data.code);
    if (res.data.code == 200) {
      title2.value = "查看发布需求";
      checked.value = true;
      form1.value = res.data.data;
      // list.value = res.data.data.records;
    } else {
      console.log(res);
    }
  });
};
interface User {
  date: string;
  name: string;
  price: string;
  address: string;
  katype: string;

  number: number;
  time: string;
}

const multipleTableRef = ref<InstanceType<typeof ElTable>>();
const multipleSelection = ref<User[]>([]);
const toggleSelection = (rows?: User[]) => {
  if (rows) {
    rows.forEach((row) => {
      multipleTableRef.value!.toggleRowSelection(row, undefined);
    });
  } else {
    multipleTableRef.value!.clearSelection();
  }
};
const handleSelectionChange = (val: User[]) => {
  multipleSelection.value = val;
};
var data = []; // 创建一个空数组

for (var i = 0; i < 10; i++) {
  data.push({
    id: "45648941615641",
    name: "5月24日广州南沙活动拍摄",

    price: "￥5000.00",
    time: "2023-06-08 15:14",
    katype: 1,
    faid: "/",
    number: 34,
  }); // 将相同的数据添加到数组中
}
const tableData: User[] = data;
// 删除
let dialogDelVisible = ref(false);
const ids = ref([]);
const handleDel = (index, row) => {
  ids.value = [];
  ids.value.push(row.id);
  dialogDelVisible.value = true;
};
const dlt = () => {
  Axios(
    "post",
    "/material/material/need/del",
    ids.value,
    false,
    function (res) {
      // console.log(res.data.code);

      if (res.data.code == 200) {
        ElMessage.success("删除成功");
        dialogDelVisible.value = false;
        getList();
      } else {
        console.log(res);
      }
    }
  );
};
//评价
let dialogEvaluateVisible = ref(false);
const handleEvaluate = (index, row, type) => {
  evaluateObj.value.needId = row.id;
  dialogEvaluateVisible.value = true;
};
let evaluateObj = ref({});
const evaluate = () => {
  evaluateObj.value.type = 1;
  if (!evaluateObj.value.evaluateStar || !evaluateObj.value.evaluateContent) {
    return ElMessage.warning("内容不能为空，请选择评级和输入内容");
  }
  Axios(
    "post",
    "/material//material/need/evaluate",
    evaluateObj.value,
    false,
    function (res) {
      if (res.data.code == 200) {
        dialogEvaluateVisible.value = false;
        evaluateObj.value = {};
        ElMessage.success("评价成功");
        getList();
      } else {
        console.log(res);
      }
    }
  );
};
//合作
let dialogCooperationVisible = ref(false);
const handleCooperation = (index, row, type) => {
  dialogCooperationVisible.value = true;
};
//确认合作
let cooperationVisible = ref(false);
let obj = ref({});
const handleCooperationVerify = (index, row, type) => {
  cooperationVisible.value = true;
  obj.value = row;
};
const Verify = () => {
  let obj1 = { ...obj.value };
  Axios("post", "/material/material/need/confirm", obj1, false, function (res) {
    if (res.data.code == 200) {
    } else {
      console.log(res);
    }
  });
};
// 选择合伙人
let obj1 = ref({});
const selectPeople = (item) => {
  obj1.value.id = item.id;
  console.log(obj1.value.id);
  numberOfApplicantsSelectRef.value.forEach((e) => {
    e.init();
  });
};
let payVisible = ref(false);
const handlePay = () => {
  if (JSON.stringify(obj1.value) != "{}") {
    let id;
    for (const e of numberOfApplicantsSelectRef.value) {
      if (e.radio) {
        console.log(e.radio);
        id = e.radio;
        break; // 停止循环
      }
    }
    if (id) {
      Axios(
        "post",
        `/material/material/need/choiceUser?id=${obj1.value.id}`,
        {},
        false,
        function (res) {
          if (res.data.code == 200) {
            ElMessage.success("选择合伙人成功");
            peopleSelectVisible.value = false;
            getList();
            console.log(res);
          } else {
            console.log(res);
          }
        }
      );
    } else {
      ElMessage.warning("请选择选择合作人");
    }

    //payVisible.value = true;
  } else {
    ElMessage.warning("请选择选择合作人");
  }
};

// 付款
const Payment = ref({});
const PaymentChoice = (index, row) => {
  Payment.value.price = row.price;
  Payment.value.id = row.id;
  payVisible.value = true;
};
const PartnersMobileNumber1 = ref();
const CloseQrCode = (e) => {
  payVisible.value = false;
  getList();
  Axios("get", `/material/material/need/${e}`, "", false, function (res) {
    if (res.data.code == 200) {
      PartnersMobileNumber.value = true;
      PartnersMobileNumber1.value = res.data.data.info.partyBContactInfo;
    } else {
      console.log(res);
    }
  });
};
const Payment1 = () => {
  if (Payment.value.value === "zfb") {
    let id = Payment.value.id;
    Axios(
      "post",
      `/material/material/need/create-pay/ALIPAY/${id}`,
      {},
      false,
      function (res) {
        if (res.data.code == 200) {
          Payment.value.img = res.data.data.qrcode;
          TwoDimensionalCodeRef.value.init(
            Payment.value.img,
            res.data.data.sceneId,
            id
          );
        } else {
          console.log(res);
        }
      }
    );
  } else {
    if (Payment.value.value === "wx") {
      let id = Payment.value.id;
      Axios(
        "post",
        `/material/material/need/create-pay/WXPAY/${id}`,
        {},
        false,
        function (res) {
          if (res.data.code == 200) {
            Payment.value.img = res.data.data.qrcode;
            TwoDimensionalCodeRef.value.init(
              Payment.value.img,
              res.data.data.sceneId,
              id
            );
          } else {
            console.log(res);
          }
        }
      );
    } else {
      ElMessage.warning("请选择付款方式");
    }
  }
};
//结算
let settlementObj = ref({});
let dialogAccountVisible = ref(false);
const handleAccount = (index, row, type) => {
  if (!Array.isArray(row._deliveryFileArray)) {
    row._deliveryFileArray = row.deliveryFile.split(",");
    row.deliveryFile = row._deliveryFileArray.map((url) => {
      // 使用正则表达式提取URL中的文件名部分
      const name = getFileName(url);
      return { name, url };
    });
  }

  settlementObj.value = row;
  dialogAccountVisible.value = true;
};
const getFileName = (file) => {
  file = file.slice(0, file.lastIndexOf("?"));
  file = file.slice(file.lastIndexOf("/") + 1);
  const prefix = file.substring(file.lastIndexOf("_"), file.lastIndexOf("."));
  file = file.replace(prefix, "");
  return decodeURI(file);
};
const SettleAnAccount = () => {
  // console.log(settlementObj.value.hasOwnProperty("deliveryFile"));
  let obj = { ...settlementObj.value };

  if (obj && obj.hasOwnProperty("deliveryFile")) {
    delete obj.deliveryFile;
  } else {
    console.log(123);
  }
  // return console.log(1231);

  Axios(
    "post",
    `/material/material/need/settlement`,
    obj,
    false,
    function (res) {
      if (res.data.code == 200) {
        ElMessage.success("结算成功");
        getList();
        dialogAccountVisible.value = false;
      } else {
        console.log(res);
      }
    }
  );
};
//文件查看

let dialogAccountViewVisible = ref(false);
const handleFileView = (index, row, type) => {
  if (!row.deliveryFile) return ElMessage.warning("等待对方交付...");

  if (!Array.isArray(row._deliveryFileArray)) {
    row._deliveryFileArray = row.deliveryFile.split(",");
    row.deliveryFile = row._deliveryFileArray.map((url) => {
      // 将 HTTP 替换为 HTTPS
      const httpsUrl = url.replace("http://", "https://");

      const name = getFileName(httpsUrl);
      return { name, url: httpsUrl };
    });
  }
  settlementObj.value = row;
  dialogAccountViewVisible.value = true;
};
//查看报名人数
let peopleVisible = ref(false);
const handlePeople = (index, row, type) => {
  peopleVisible.value = true;
};

// 合作人选择
const list1 = ref({});
const loading = ref(null);
let peopleSelectVisible = ref(false);
let params = {
  pageIndex: 1,
  pageSize: 5,
  needId: "",
};
const title1 = ref("");
const handlePeopleSelect = async (index, row, type) => {
  params.needId = row.id;
  console.log();
  if (row.signUpNum) {
    loading.value = ElLoading.service({
      lock: true,
      text: "Loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    Axios(
      "GET",
      "/material/material/need/signUpInfo",
      params,
      false,
      function (res) {
        if (res.data.code == 200) {
          list1.value = res.data.data.records;
          form.value.total = res.data.data.total;
          loading.value.close();
        } else {
          console.log(res);
        }
      }
    );
    obj1.value = {};
    title1.value = "选择合伙人";

    peopleSelectVisible.value = true;
    // console.log();
    let a = function () {
      numberOfApplicantsSelectRef.value.forEach((e) => {
        e.init();
      });
    };
    numberOfApplicantsSelectRef.value ? a() : "";
  } else {
    ElMessage.warning("该需求暂无合作人");
  }
};
let params1 = {
  pageIndex: 1,
  pageSize: 5,
  needId: "",
};
const handlePeopleSelect1 = (index, row, type) => {
  params1.needId = row.id;
  if (row.signUpNum) {
    Axios(
      "GET",
      "/material/material/need/signUpInfo",
      params1,
      false,
      function (res) {
        if (res.data.code == 200) {
          list1.value = res.data.data.records;
          form.value.total = res.data.data.total;
        } else {
          console.log(res);
        }
      }
    );
    obj1.value = {};
    title1.value = "查看合伙人";
    peopleSelectVisible.value = true;
  } else {
    ElMessage.warning("该需求暂无合作人");
  }
};
//客服
let serviceVisible = ref(false);
const handleService = (index, row, type) => {
  serviceVisible.value = true;
};
// 选择支付方式
const paymentOptions = ref([
  { name: "微信", icon: "@/assets/img/weixin.png", value: "wx" },
  { name: "支付宝", icon: "@/assets/img/zhifubao.png", value: "zfb" },
]);

const selectedPaymentOption = ref(null);

const selectPaymentOption = (option) => {
  selectedPaymentOption.value = option;
  Payment.value.value = option.value;
};
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);
@import url(/src/assets/css/com.css);

.requirement_management {
  display: flex;
  margin: 0 auto;
}

.topBtn {
  height: 0.33rem;
  margin-top: 0.05rem;
  line-height: 0.33rem;
  font-size: 0.14rem;
  padding: 0 0.24rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;
  color: #ffff;
  background: #c01a26;
  margin-left: 0.2rem;
}

.topBtn1 {
  height: 0.33rem;
  margin-top: 0.05rem;
  line-height: 0.33rem;
  font-size: 0.14rem;
  padding: 0 0.14rem;
  text-align: center;
  color: #333333;
  background: #ffffff;
  border-radius: 0.2rem;
  opacity: 1;

  color: #ffff;
  background: #c01a26;
  margin-left: 0.2rem;
}

/deep/ .el-table th.el-table__cell.is-leaf {
  background: #e3e6ec !important;
}

/deep/.el-tabs__nav-wrap::after {
  display: none;
}

/deep/.el-dialog.is-align-center {
  border-radius: 20px !important;
}

/deep/.rate .el-icon,
/deep/.rate .el-icon svg {
  height: 2em !important;
  width: 2em !important;
}

/deep/.el-tabs__active-bar {
  display: none !important;
}

/deep/.el-tabs__item:hover {
  color: #c01a26;
}

/deep/.el-tabs__item.is-active {
  color: #c01a26;
}

/deep/.el-tabs__nav-scroll {
  padding-left: 0.12rem;
}

/deep/.dataBtnSubmit,
.dataBtnClose {
  margin-bottom: 0;
}

.payItem {
  width: 0.96rem;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
  color: #333;
  border-radius: 0.04rem 0.04rem 0.04rem 0.04rem;
  opacity: 1;
  border: 0.01rem solid #e5e6eb;
  margin-left: 0.12rem;
  display: flex;
  justify-content: center;
}

.payItem.selected {
  border: 1px solid #c01a26;
  position: relative;
  background-image: url("@/assets/img/paySelect.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 30% 80%;
}

.payText2 {
  text-align: center;
  color: #86909c;
  font-size: 0.14rem;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #c01a26 !important;
  background: #c01a26 !important;
}

.fileIcon {
  width: 0.12rem;
  height: 0.13rem;
  margin-top: 0.02rem;
  margin-right: 0.04rem;
  background: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.downloadIcon {
  width: 0.11rem;
  height: 0.11rem;
  background: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.dataBtn {
  width: 0.88rem;
  padding: 0.08rem 0.16rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
}

.dataBtnQx {
  margin-right: 0.2rem;
  border: 1px solid #86909c;
  color: #333333;
  background: transparent;
}

.table_title {
  width: 0.7rem;
  flex: none;
}

.table_name {
  width: 0.4rem;
  flex: none;
}
</style>
